<script>
	import TransactionView from "./TransactionView.svelte";
	import { getHoldingRequiredFieldErrors } from "./holdingValidation";

	export let holding;
	export let registrationToken;
	export let showValidationErrors = false;

	$: hasValidationErrors =
		showValidationErrors &&
		(getHoldingRequiredFieldErrors(holding).length > 0 ||
			holding.HoldingTransactions?.some((transaction) => transaction.hasPriceError));
</script>

<div class="holding-info">
	<div><strong>Holding Name:</strong></div>
	<div>{holding.HoldingName || "N/A"}</div>
	<div><strong>Registered Owner:</strong></div>
	<div>{holding.RegisteredOwner || "N/A"}</div>
	<div><strong>SRN/HIN:</strong></div>
	<div>{holding.HoldingIdentificationNumber || "N/A"}</div>
	<div><strong>Shares:</strong></div>
	<div>{holding.NumberOfShares || "N/A"}</div>
	{#if !holding.showFileUpload}
		<div><strong>Number of Transactions:</strong></div>
		<div>{holding.HoldingTransactions.length || "N/A"}</div>
	{/if}
</div>

{#if hasValidationErrors}
	<div class="holding-validation-errors" role="alert">
		Holding has errors or missing required fields. Please review the information and correct any errors before proceeding.
	</div>
{/if}

<TransactionView bind:holding {registrationToken} />

<style>
	.holding-info {
		display: grid;
		grid-template-columns: max-content 1fr;
		gap: 0.25rem 1rem;
		align-items: start;
	}

	.holding-validation-errors {
		color: var(--color-error);
		margin-top: 0.75rem;
	}

	@media (max-width: 768px) {
		.holding-info {
			grid-template-columns: 1fr;
			gap: 0;
		}
		.holding-info div:nth-child(even) {
			padding-left: 1rem;
			margin-bottom: 0.5rem;
		}
	}
</style>
